import React, { useState, useEffect } from 'react';
import "./sectorTabs.css";
const SectorTabs = (name) => {
    const [activeTab, setActiveTab] = useState('');
    const [tabContent, setTabContent] = useState({});
    const [loading, setLoading] = useState(true);



    const apiUrl = "https://linklogic-backend.vercel.app/api/data?type=sector&name=" + name['name'];





    useEffect(() => {
        const fetchData = async () => {
            try {

                const response = await fetch(apiUrl);
                if (!response.ok) throw new Error("Network response was not ok");
                const data = await response.json();

                setTabContent(data);

            } catch (error) {
                console.error("Fetch error:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [apiUrl]); // Runs when apiUrl changes



    const renderValueChain = () => {
        const sectionData = tabContent[activeTab];

        return Object.keys(sectionData).map((key) => {
            const item = sectionData[key];

            return (
                <div key={key} className="section-container">
                    <h2 className="section-title">{key}</h2>
                    {item.Role && <p className="section-role">{item.Role}</p>}

                    {item["Key Players"] && (
                        <div className="section-block">
                            <h3 className="section-subtitle">Key Players:</h3>
                            <ul className="section-list">
                                {item["Key Players"].map((player, index) => (
                                    <li key={index}>{player}</li>
                                ))}
                            </ul>
                        </div>
                    )}

                    {/* Handle High-Value and Mid-Value Materials */}
                    {["High-Value Materials", "Mid-Value Materials"].map((category) =>
                        item[category] ? (
                            <div key={category} className="section-block">
                                <h3 className="section-subtitle">{category}:</h3>
                                {Object.keys(item[category]).map((material) => {
                                    const details = item[category][material];
                                    return (
                                        <div key={material} className="material-item">
                                            <h4 className="material-title">{material}</h4>
                                            <p className="material-usage"><strong>Used for:</strong> {details["Used for"]}</p>
                                            {details["High value due to"] && (
                                                <ul className="material-list">
                                                    {details["High value due to"].map((reason, index) => (
                                                        <li key={index}>{reason}</li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        ) : null
                    )}

                    {/* Handle Applications (for End-User Markets) */}
                    {item.Applications && (
                        <div className="section-block">
                            <h3 className="section-subtitle">Applications:</h3>
                            <ul className="section-list">
                                {item.Applications.map((app, index) => (
                                    <li key={index}>{app}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
            );
        });
    };


    const renderPolicy = () => {
        const policyData = tabContent[activeTab];
        return Object.keys(policyData).map((key) => {
            const item = policyData[key];

            return (
                <div key={key} className="policy-container">
                    <h2 className="policy-title">{key}</h2>

                    {/* Impact Section */}
                    {item.impact && (
                        <div className="policy-block">
                            <h3 className="policy-subtitle">Impact:</h3>
                            <ul className="policy-list">
                                {item.impact.map((impactItem, index) => (
                                    <li key={index}>{impactItem}</li>
                                ))}
                            </ul>
                        </div>
                    )}

                    {/* Scheme Section */}
                    {item.scheme && (
                        <div className="policy-block">
                            <h3 className="policy-subtitle">Scheme:</h3>
                            <ul className="policy-list">
                                {item.scheme.map((schemeItem, index) => (
                                    <li key={index}>{schemeItem}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
            );
        });
    };


    const renderCompanies = () => {
        const companyData = tabContent[activeTab];
        return (
            <div className="companies-container">
                <table className="companies-table">
                    <thead>
                        <tr>
                            <th>Company</th>
                            <th>Intrinsic Value</th>
                            <th>Market Cap (Cr.)</th>
                            <th>Sales (Cr.)</th>
                            <th>Sales Growth (%)</th>
                            <th>P/E Ratio</th>
                            <th>PEG Ratio</th>
                            <th>Debt (Cr.)</th>
                            <th>Debt to Equity</th>
                            <th>OPM (%)</th>
                            <th>PAT (Cr.)</th>
                            <th>Change in Promoter Holding (%)</th>
                            <th>Promoter Holding (%)</th>
                            <th>ROCE (%)</th>
                            <th>ROE (%)</th>
                            <th>Face Value</th>
                            <th>EPS</th>
                            <th>Current Ratio</th>
                            <th>Quick Ratio</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Object.keys(companyData).map((company) => {
                            const details = companyData[company];
                            return (
                                <tr key={company}>
                                    <td>{company}</td>
                                    <td>{details["Intrinsic Value"]}</td>
                                    <td>{details["Market Capitalization"]}</td>
                                    <td>{details["Sales"]}</td>
                                    <td>{details["Sales growth"]}</td>
                                    <td>{details["Price to Earning"]}</td>
                                    <td>{details["PEG Ratio"] || "N/A"}</td>
                                    <td>{details["Debt"]}</td>
                                    <td>{details["Debt to equity"]}</td>
                                    <td>{details["OPM"]}</td>
                                    <td>{details["Profit after tax"]}</td>
                                    <td>{details["Change in promoter holding"]}</td>
                                    <td>{details["Promoter holding"]}</td>
                                    <td>{details["Return on capital employed"]}</td>
                                    <td>{details["Return on equity"]}</td>
                                    <td>{details["Face value"]}</td>
                                    <td>{details["EPS"]}</td>
                                    <td>{details["Current ratio"]}</td>
                                    <td>{details["Quick ratio"]}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    };


    const renderCapex = () => {
        const capexData = tabContent[activeTab];
        return (
            <div className="capex-container">
                <h2>Total Investment: {capexData["Total Investment"]}</h2>
                {Object.keys(capexData.Sectors).map((sector) => {
                    const sectorData = capexData.Sectors[sector];
                    return (
                        <div key={sector} className="sector">
                            <h3>{sector}</h3>
                            <p><strong>Total Investment:</strong> {sectorData["Total Investment"]}</p>
                            {sectorData["Total Capacity"] && (
                                <p><strong>Total Capacity:</strong> {sectorData["Total Capacity"]}</p>
                            )}
                            {sectorData.Investments && (
                                <table className="capex-table">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Location</th>
                                            <th>Investment</th>
                                            <th>Description</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {sectorData.Investments.map((investment, index) => (
                                            <tr key={index}>
                                                <td>{investment.Name}</td>
                                                <td>{investment.Location || "N/A"}</td>
                                                <td>{investment.Investment || "N/A"}</td>
                                                <td>{investment.Description}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                            {sectorData["Other Initiatives"] && (
                                <ul>
                                    {sectorData["Other Initiatives"].map((initiative, index) => (
                                        <li key={index}>{initiative}</li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    );
                })}
            </div>
        );
    };

    const renderOrderBook = () => {
        const orderBookData = tabContent[activeTab];

        return (
            <div className="order-book-container">
                <h2>Order Book Summary</h2>
                <table className="order-summary-table">
                    <tbody>
                        {[
                            "Total Orders",
                            "Planned Orders",
                            "Executed Orders",
                            "Completed Orders",
                            "Total Planned Value",
                            "Total Executed Value",
                            "Total Completed Value"
                        ].map((key) =>
                            orderBookData[key] ? (
                                <tr key={key}>
                                    <td>{key}</td>
                                    <td>{orderBookData[key]}</td>
                                </tr>
                            ) : null
                        )}
                    </tbody>
                </table>

                <h3>Key Areas</h3>
                {Object.entries(orderBookData["Key Areas"]).map(([area, data]) => (
                    <div key={area} className="order-section">
                        <h4>{area}</h4>
                        {data["Total Value"] && data["Total Value"] !== "Not mentioned" && (
                            <p><strong>Total Value:</strong> {data["Total Value"]}</p>
                        )}
                        <ul>
                            {data["Major Projects"].map((project, index) => (
                                <li key={index}>{project}</li>
                            ))}
                        </ul>
                    </div>
                ))}

                {["Major Completed Projects", "Major Executed Projects", "Major Planned Projects"].map(
                    (section) =>
                        orderBookData[section] && orderBookData[section].length > 0 && (
                            <div key={section}>
                                <h3>{section.replace(/Major /, "")}</h3>
                                <ul>
                                    {orderBookData[section].map((project, index) => (
                                        <li key={index}>{project}</li>
                                    ))}
                                </ul>
                            </div>
                        )
                )}
            </div>
        );
    };








    const tabOrder = [
        "Overview",
        "Value Chain",
        "Policy / Sectoral Boost",
        "Key Indicators",
        "Companies",
        "Capex",
        "Order Book"
    ]
        ;
    const styles = {
        container: {
            maxWidth: '1200px',
            margin: '0 auto',
            padding: '20px',
            fontFamily: 'Arial, sans-serif'
        },
        header: {
            textAlign: 'left',
            marginBottom: '30px',
            color: '#333'
        },
        companyName: {
            fontSize: '2.5em',
            marginBottom: '20px',
            color: '#2c3e50'
        },
        sectorsContainer: {
            marginBottom: '30px',
            padding: '20px',
            backgroundColor: '#f8f9fa',
            borderRadius: '8px'
        },
        sectorGrid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))',
            gap: '20px',
            marginTop: '15px'
        },
        sectorCard: {
            backgroundColor: 'white',
            padding: '15px',
            borderRadius: '6px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
        },
        sectorTitle: {
            color: '#2c3e50',
            fontSize: '1.2em',
            marginBottom: '10px',
            fontWeight: 'bold'
        },
        segmentList: {
            margin: '0',
            padding: '0 0 0 20px'
        },
        segmentItem: {
            color: '#666',
            margin: '5px 0'
        },
        tabsContainer: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: '10px',
            marginBottom: '20px'
        },
        tab: {
            padding: '10px 20px',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            backgroundColor: '#f0f0f0',
            transition: 'background-color 0.3s'
        },
        activeTab: {
            backgroundColor: '#4f899d',
            color: 'white'
        },
        contentContainer: {
            backgroundColor: '#f9f9f9',
            padding: '0px',
            borderRadius: '0px 5px',
            borderBottom: 'none',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            overflowY: 'scroll', // Enables vertical scrolling
            maxHeight: '450px',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
        },
        title: {
            marginTop: '0',
            marginBottom: '15px',
            color: '#333'
        },
        content: {
            lineHeight: '1.6',
            color: '#666'
        }
    };

    return (
        <div style={styles.container}>
            <header style={styles.header}>
                <h1 style={styles.companyName}>{name['name']}</h1>


            </header>

            <div style={styles.tabsContainer}>
                {tabOrder
                    .filter((key) => Object.keys(tabContent || {}).includes(key))
                    .map((key) => (
                        <button
                            key={key}
                            style={{
                                ...styles.tab,
                                ...(activeTab === key ? styles.activeTab : {}),
                            }}
                            onClick={() => setActiveTab(key)}
                        >
                            {key}
                        </button>
                    ))}
            </div>

            <div style={styles.contentContainer}>
                {(activeTab === 'Value Chain') && renderValueChain()}
            </div>



            <div style={styles.contentContainer}>
                {(activeTab === 'Policy / Sectoral Boost') && renderPolicy()}
            </div>

            <div style={styles.contentContainer}>
                {(activeTab === 'Companies') && renderCompanies()}
            </div>

            <div style={styles.contentContainer}>
                {(activeTab === 'Capex') && renderCapex()}
            </div>

            <div style={styles.contentContainer}>
                {(activeTab === 'Order Book') && renderOrderBook()}
            </div>





        </div>
    );
};

export default SectorTabs;